import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import {
  Control,
  Controller,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { Column, Row } from 'further-ui/components/Layout';
import Switch from 'further-ui/components/Switch';
import { PeriodEndReportFormValues } from './schema';

const StyledColumn = styled(Column)({
  maxWidth: '400px',
});

type SwitchRowProps = {
  text: string;
  children: React.ReactNode;
};

const SwitchRow: FC<SwitchRowProps> = ({ children, text }) => (
  <Row centered fullWidth justify="space-between">
    <Typography variant="h6">{text}</Typography>
    {children}
  </Row>
);

type Props = {
  control: Control<PeriodEndReportFormValues>;
  setValue: UseFormSetValue<PeriodEndReportFormValues>;
};

const NotificationPreferences: FC<Props> = ({ control, setValue }) => {
  const recipients = useWatch({ control, name: 'recipients' });
  const notifyViaEmail = useWatch({
    control,
    name: 'notificationPreferences.notifyViaEmail',
  });

  const updateNotifyByEmail = (value: boolean) => {
    setValue('notificationPreferences.notifyViaEmail', value);
    if (!value) {
      setValue('notificationPreferences.attachPdfUpdateToEmail', false);
    }
    recipients.forEach((_, index) => {
      setValue(`recipients.${index}.notifyViaEmail`, value, {
        shouldDirty: true,
      });
    });
  };

  return (
    <StyledColumn spacing="lg">
      <Typography variant="h5" color="grey.900">
        Notification preferences
      </Typography>
      <SwitchRow text="Notify investors via email">
        <Controller
          control={control}
          name="notificationPreferences.notifyViaEmail"
          render={({ field }) => (
            <Switch checked={field.value} onChange={updateNotifyByEmail} />
          )}
        />
      </SwitchRow>
      <SwitchRow text="Attached PDF update to email">
        <Controller
          control={control}
          name="notificationPreferences.attachPdfUpdateToEmail"
          render={({ field }) => (
            <Switch
              checked={field.value}
              onChange={field.onChange}
              disabled={!notifyViaEmail}
            />
          )}
        />
      </SwitchRow>
    </StyledColumn>
  );
};

export default NotificationPreferences;
